import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=5508f484&scoped=true"
import script from "./filter.vue?vue&type=script&lang=js"
export * from "./filter.vue?vue&type=script&lang=js"
import style0 from "./filter.vue?vue&type=style&index=0&id=5508f484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508f484",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzTabs: require('/drone/src/components/pz-tabs/index.vue').default})
